import styled from 'styled-components';
import { Text } from '../Text';

export const MainTitle = styled(Text)`
  font-family: 'FS Emeric';
  font-weight: 600;
  font-size: ${(props) => props.fontSize || "32px"};
  color: var(--orangeColorMain);
  line-height: 30px;
  margin-bottom: 40px;
`;